const footerNav = [
  { href: "#features", label: "核心功能" },
  { href: "#recommend", label: "热门推荐" },
  { href: "#scenarios", label: "阅读场景" },
  { href: "#voices", label: "用户口碑" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 py-12">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">尾巴漫画网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              尾巴漫画网支持阅读书签与跨设备同步，自动保存历史记录与阅读足迹，
              换手机、换平板也能断点续读，收藏同步不丢失。
            </p>
          </div>

          <nav className="grid grid-cols-2 gap-x-10 gap-y-3" aria-label="页脚导航">
            {footerNav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap text-sm text-background-300 transition-colors hover:text-accent-300"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-start gap-4 border-t border-background-700 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-background-400">
            © 2026 尾巴漫画网 · 让每一段阅读都不断档
          </p>
          <div className="flex items-center gap-3">
            <a
              href="#top"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-700 text-background-200 transition-colors hover:bg-primary-500 hover:text-background-50"
              aria-label="回到顶部"
            >
              <i className="ri-arrow-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}